import { Component, Input, EventEmitter } from '@angular/core';
import { TrabajadoresApiService } from '../../../../../service/api/trabajadores-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseView } from 'src/app/view/base-view';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { Utils } from '../../../../../common/utils';
import { StorageManager } from '../../../../../common/storage-manager.class';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { Filtering } from 'src/app/service/filtering/filtering';
import { Router } from '@angular/router';

import type { OnInit } from '@angular/core';
import { MessageService, TreeNode } from 'primeng/api';
import { Fichaje } from 'projects/fichajes/src/app/models/Fichajes.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { CargoModel } from 'src/app/models/trabajadores/cargos.model';

@Component({
    selector: 'app-fichajes-hours-minutes',
    standalone: false,
    templateUrl: './fichajes_hours_minutes.component.html',
    styleUrls: ['./fichajes_hours_minutes.component.scss']
})

export class FichajesHourMinuteComponent extends BaseView<Fichaje> implements OnInit {

    @Input() saveButtonClick: EventEmitter<object> = new EventEmitter<object>();
    @Input() undoButtonClick: EventEmitter<object> = new EventEmitter<object>();

    public appName = environment.appName;
    public showTrabajadoresCuadrillas = environment.features.showTrabajadoresCuadrillas;
    public showFichajesCargos = environment.features.showFichajesCargos;
    public showFichajesExportarCSV = environment.features.showFichajesExportarCSV;
    public showFormatHourMinute = environment.features.showFormatHourMinute;
    public showFichajesUbicacion = environment.features.showFichajesUbicaciones;

    public override filtering: Filtering<Fichaje> = new Filtering<Fichaje>();

    public getRequest: RequestHandler<Fichaje[]> = this.trabajadoresApi.fichajesGET;
    public postRequest: RequestHandler<Fichaje[]> = this.trabajadoresApi.fichajesPOST;
    public deleteRequest: RequestHandler<Fichaje> = this.trabajadoresApi.fichajesDELETE;
    public isPerforming = false;

    public usuarioActual = StorageManager.getUser();
    public trabajadores: MantenimientoModel[] = [];
    public cuadrillas: {label: string, value: MantenimientoModel | null}[] = [];
    public cuadrilla: {id: string} = {id: '0'};
    public cargos: {label: string, value: CargoModel | null}[] = [];
    public cargo: {id: string} = {id: '0'};
    public RANDOM_VALUE_MARGIN = (this.appName === 'naturfrut') ? 400 : 0;

    public editingEnabled = false;
    public date = moment().toDate();
    public es = Utils.es;
    public override model = {} as Fichaje;
    public isDownloadingCsv = false;
    public almacenFilter = '';

    public cols: ColInterface[] = [];
    public colsNoEdit: ColInterface[] = [
        { field: 'nif', header: 'NIF' },
        { field: 'nombre', header: 'Nombre' },
        { field: 'horaEntrada', header: 'Entrada (mañana)' },
        { field: 'horaSalida', header: 'Salida (mañana)' },
        { field: 'horaEntradaTarde', header: 'Entrada (tarde)' },
        { field: 'horaSalidaTarde', header: 'Salida (tarde)' },
        { field: this.showFormatHourMinute ? 'hour_minute' : 'horas', header: 'Horas' },
        { field: 'cargo_nombre', header: 'Cargo', visible: this.showFichajesCargos }
    ];

    public colsEdit: ColInterface[] = [
        { field: 'nif', header: 'NIF' },
        { field: 'nombre', header: 'Nombre' },
        { field: 'horaEntrada', header: 'Entrada (mañana)', editable: true, maxLength: 5 },
        { field: 'horaSalida', header: 'Salida (mañana)', editable: true, maxLength: 5 },
        { field: 'horaEntradaTarde', header: 'Entrada (tarde)', editable: true, maxLength: 5 },
        { field: 'horaSalidaTarde', header: 'Salida (tarde)', editable: true, maxLength: 5 },
        { field: this.showFormatHourMinute ? 'hour_minute' : 'horas', header: 'Horas', editable: true, maxLength: 5 },
        { field: 'cargo_nombre', header: 'Cargo', visible: this.showFichajesCargos }
    ];
    public showFichajes  = true;
    public horasString = '';
    public hour_minute = '';

    constructor(public trabajadoresApi: TrabajadoresApiService,
        private dashboardEvent: DashboardService,
        private messageService: MessageService,
        private router: Router
    ) {
        super(dashboardEvent, 
            trabajadoresApi.fichajesGET, 
            trabajadoresApi.fichajesDELETE);
    
    }

    ngOnInit() {
    
        this.initFilters();
        if (this.showTrabajadoresCuadrillas) {
            this.getCuadrillas();
        }
        if (this.showFichajesCargos) {
            this.getCargos();
        }

        this.cols = this.colsNoEdit;
        this.dashboardEvent.setSubmenuItem('fichajes-test');

        this.trabajadoresApi.fichajesGET.response(() => {
            this.isPerforming = false;
        });
    }

    redirectTo(uri: string){
        this.router.navigateByUrl('/', {skipLocationChange: false}).then(() =>
            this.router.navigate([uri])).catch (e => {
            console.log('catch en navigationByUrl: ' + e);
        }
        );
    }


    formatoHorasMinutos(horaEntrada: string, horaSalida: string) {
        let timeStr: string | string[] = horaEntrada;
        timeStr = timeStr.split(':');
    
        const h = timeStr[0] ?? '',
            m = timeStr[1] ?? '';
    
        const newTime = moment(`${horaSalida} 2021-04-05`, 'HH:mm YYYY-MM-DD')
            .subtract({ hours: +h, minutes: +m })
            .format('HH:mm');
        
    
        return newTime;
    
    }

    timeToDecimal(t: string) {
        const tArray = t.split(':');
        return parseInt(tArray[0] ?? '', 10) * 1 + parseInt(tArray[1] ?? '', 10) / 60;
        // var arr:string[] = t.split(':');
        // var dec:any = parseInt( (( parseInt(arr[1])  / 6) * 10, 10).toString());

    // return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
    }

    mostrarUbicacion(coordenadas: string) {
        console.log(coordenadas);
        if (coordenadas) {
            window.open('https://www.google.com/maps/search/?api=1&query=' + coordenadas, '_blank');
        } else {
            this.messageService.add(
                { 
                    severity: 'error', 
                    summary: 'Sin Ubicación Conocida', 
                    detail: 'No hay ubicación registrada para este fichaje.' 
                }
            );   
        }
    }

    public changeDate() {
        this.getRequest.safePerform({ fecha: moment(this.date).format('DD/MM/YYYY') } as never);
    }

    public autofillHoras(        
        horas: HTMLInputElement, 
        horaEntrada: HTMLInputElement, 
        horaSalida: HTMLInputElement, 
        horaEntradaTarde: HTMLInputElement, 
        horaSalidaTarde: HTMLInputElement
    ) {
        const h1 = moment((horaEntrada.value || '00:00'), 'hh:mm').hours();
        const m1 = moment((horaEntrada.value || '00:00'), 'hh:mm').minutes();
        const h2 = moment((horaEntradaTarde.value || '00:00'), 'hh:mm').hours();
        const m2 = moment((horaEntradaTarde.value || '00:00'), 'hh:mm').minutes();

        let horasMañana = 0;
        let minutosMañana = 0;
        let horasTarde = 0;
        let minutosTarde = 0;
        if ( this.showFormatHourMinute ) {
      
            const horaEntradaFormateada = moment(horaEntrada.value || '00:00', 'HH:mm').format('HH:mm');
            const horaSalidaFormateada = moment(horaSalida.value || '00:00', 'HH:mm').format('HH:mm');
            const horaEntradaTardeFormateada = moment(horaEntradaTarde.value || '00:00', 'HH:mm').format('HH:mm');
            const horaSalidaTardeFormateada = moment(horaSalidaTarde.value || '00:00', 'HH:mm').format('HH:mm');
   
      
            let diffManana = '';
            let diffTarde = '';
      
            let checkMorning = false;
            let checkAfter = false;
            if (horaEntrada.value && horaSalida.value) {
                diffManana = this.formatoHorasMinutos( horaEntradaFormateada, horaSalidaFormateada );
                checkMorning = true;
            }
            if (horaEntradaTarde.value && horaSalidaTarde.value) {
                diffTarde = this.formatoHorasMinutos( horaEntradaTardeFormateada, horaSalidaTardeFormateada);
                checkAfter = true;
            }

            if (checkMorning) { 
                this.horasString =  diffManana;       
            }

            if (checkAfter){ 
                this.horasString = diffTarde;
            }

            if ( checkMorning && checkAfter) {
                this.horasString =  
                moment(diffTarde, 'HH:mm').add(diffManana.split(':')[0], 'h').add(diffManana.split(':')[1], 'm').format('HH:mm');
            }

            this.hour_minute = this.horasString;
      
        } else {
            const diffManana = moment((horaSalida.value || horaEntrada.value || '00:00'), 'hh:mm')
                .subtract(h1, 'hours')
                .subtract(m1, 'minutes');
            const diffTarde = moment((horaSalidaTarde.value || horaEntradaTarde.value || '00:00'), 'hh:mm')
                .subtract(h2, 'hours')
                .subtract(m2, 'minutes');

            if (horaEntrada.value && horaSalida.value) {
                horasMañana = diffManana.hours();
                minutosMañana = diffManana.minutes();
            }
            if (horaEntradaTarde.value && horaSalidaTarde.value) {
                horasTarde = diffTarde.hours();
                minutosTarde = diffTarde.minutes();
            }

            horas.value = (horasMañana + horasTarde + ((minutosMañana + minutosTarde) / 60)).toFixed(2);
        }

   

        if (+(horas.value || 0) > 23 || +(horas.value || 0) < 0 || ['0', 0].includes(horas.value ?? '')) {
            horas.value = '';
        }
    }

    public save(horas?: string, horaEntrada?: string, horaSalida?: string, horaEntradaTarde?: string, horaSalidaTarde?: string) {
    
        this.isPerforming = true;
        const fichajesToSend: Fichaje[] = [];
    
        const toSend = {
            horaEntrada: '',
            horaSalida: '',
            horaEntradaTarde: '',
            horaSalidaTarde: '',
            horas: null,
        };
    
        (this.filtering.value || []).forEach(fichajeNode => {
            const fichaje = fichajeNode as Fichaje;
            if ( horas == null ){
                this.horasString = '';
            }

            if (horaEntrada) {
                toSend.horaEntrada = moment(horaEntrada, 'HH:mm')
                    .subtract(Math.floor(Math.random() * this.RANDOM_VALUE_MARGIN), 'seconds').format('HH:mm');
            }

            if (horaSalida) {
                toSend.horaSalida = moment(horaSalida, 'HH:mm')
                    .subtract(Math.floor(Math.random() * this.RANDOM_VALUE_MARGIN), 'seconds').format('HH:mm');
            }
            if (horaEntradaTarde) {
                toSend.horaEntradaTarde = moment(horaEntradaTarde, 'HH:mm')
                    .subtract(Math.floor(Math.random() * this.RANDOM_VALUE_MARGIN), 'seconds').format('HH:mm');
            }
            if (horaSalidaTarde) {
                toSend.horaSalidaTarde = moment(horaSalidaTarde, 'HH:mm')
                    .subtract(Math.floor(Math.random() * this.RANDOM_VALUE_MARGIN), 'seconds').format('HH:mm');
            }
      
            if ( horas == null ){
                let diffManana = '';
                let diffTarde = '';
                let checkMorning = false;
                let checkAfter = false;
                if (fichaje.horaEntrada && fichaje.horaSalida) {
                    diffManana = this.formatoHorasMinutos( fichaje.horaEntrada , fichaje.horaSalida );
                    checkMorning = true;
                }
  
                if (fichaje.horaEntradaTarde && fichaje.horaSalidaTarde) {
                    diffTarde = this.formatoHorasMinutos( fichaje.horaEntradaTarde, fichaje.horaSalidaTarde);
                    checkAfter = true;
                }
  
                if (checkMorning) { 
                    this.horasString =  diffManana;       
                }
  
                if (checkAfter){ 
                    this.horasString = diffTarde;
                }
        
                if ( checkMorning && checkAfter) {
                    this.horasString =  moment(diffTarde, 'HH:mm')
                        .add(diffManana.split(':')[0], 'h')
                        .add(diffManana.split(':')[1], 'm')
                        .format('HH:mm');
                }

                if ( !checkMorning && !checkAfter) {
                    this.horasString =  ' ';
                }
        
            }
      
            this.hour_minute = this.horasString;  
      
            if (horas || this.horasString) {
                const sendHours = { 
                    id: fichaje.id || (fichaje.id_fichaje ?? ''),
                    horas: toSend.horas || (fichaje.horas || '').toString().replace(',', '.'),
                    horaEntrada: toSend.horaEntrada || (fichaje.horaEntrada ?? ''),
                    horaSalida: toSend.horaSalida || (fichaje.horaSalida ?? ''),
                    horaEntradaTarde: toSend.horaEntradaTarde || (fichaje.horaEntradaTarde ?? ''),
                    horaSalidaTarde: toSend.horaSalidaTarde || (fichaje.horaSalidaTarde ?? ''),
                    fecha: moment(this.date).format('DD/MM/YYYY'),
                    id_trabajador: fichaje.id_trabajador ?? '',
                    id_cliente: '0',
                    id_usuario: this.usuarioActual.id,
                    hour_minute: ''
                };
        
                if ( this.showFormatHourMinute ) {
                    sendHours.hour_minute = this.horasString;
                    sendHours.horas = (isNaN(this.timeToDecimal(this.horasString)) ? '' : this.timeToDecimal(this.horasString)).toString();
                }

                fichajesToSend.push(sendHours);
        
            }
      
        });
  
        (fichajesToSend || []).forEach(async (fichaje) => {

            await this.postRequest.toPromise(fichaje as never).then( resp => {
                console.log({resp});
                return;
            }).catch( error => {
                console.log({error});
            });
      
            this.getRequest.safePerform({ fecha: moment(this.date).format('DD/MM/YYYY') } as never);

            await this.trabajadoresApi.fichajesGET.toPromise();
            this.getRequest = this.trabajadoresApi.fichajesGET;
            this.filtering.filter();
        });

    }

    public edit() {
        this.editingEnabled = !this.editingEnabled;
        if (this.editingEnabled) {
            this.cols = this.colsEdit;
        } else {
            this.cols = this.colsNoEdit;
        }
    }

    public globalConditionalStyle(_value: string, col: ColInterface): ColStylesInterface {
        if (['horas', 'horaEntrada', 'horaSalida', 'horaEntradaTarde', 'horaSalidaTarde', 'hour_minute'].includes(col.field)) {
            return {
                textAlign: 'center'
            };
        }
        return {};
    }

    public globalVisualTransform(value: string, col: ColInterface) {
        if ( !this.showFormatHourMinute ) {
            if (['horas'].includes(col.field) && (value || 0).toString().includes('.')) {
                return Utils.decimalFormat(value, 2);
            }
        }
        return value;
   
    }

    public exportarCSV() {
        this.isDownloadingCsv = true;

        let csv = 'data:text/csv;charset=utf-8,';
        (this.filtering.value || []).forEach((row, i) => {
            if (i === 0) {
                csv += '"' + Object.keys(row).join('";"') + '"\n';
            }
            csv += '"' + Object.values(row).join('";"') + '"\n';
        });

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;
        csvLink.download = 'fichajes.csv';
        csvLink.href = encodeURI(csv);
        csvLink.click();

        this.isDownloadingCsv = false;
    }

    public formChanges(tag: string) {
        if (tag === 'es-almacen') {
            if (this.almacenFilter !== 'es-almacen') {
                this.almacenFilter = 'es-almacen';
            } else {
                this.almacenFilter = '';
            }
        }

        if (tag === 'no-es-almacen') {
            if (this.almacenFilter !== 'no-es-almacen') {
                this.almacenFilter = 'no-es-almacen';
            } else {
                this.almacenFilter = '';
            }
        }

        this.filtering.filter();

        if (this.filtering.value) {
            this.sortAlphabetically(this.filtering.value, 'nombre');
        }
    }

    public editField(value: Date | string,
    node: TreeNode<Fichaje>,
    field: string) {
        if (!node?.data) return;

        const d = node.data;
        const hhmm = this.toHHmm(value);
        (d as any)[field] = hhmm;

        const timeFormat = /^(2[0-3]|[01]?\d):([0-5]?\d)$/;

        const toDec = (s?: string): number => {
            if (!s || !timeFormat.test(s)) return 0;
            const [h, m] = s.split(':').map(n => parseInt(n, 10));
            return (h ?? 0) + (m ?? 0) / 60;
        };

        let total = 0;
        total += toDec(d.horaSalida)       - toDec(d.horaEntrada);
        total += toDec(d.horaSalidaTarde)  - toDec(d.horaEntradaTarde);
        total = Math.max(0, Math.min(24, total));

        // Evita que el datePicker perda el focus durant l’escriptura
        queueMicrotask(() => {
            if (!node?.data) return;
            d.horas = total.toFixed(2);
        });

    }

    // Convierte Date o string a "HH:mm"
    private toHHmm(v: Date | string | null | undefined): string {
        if (!v) return '';
        const d = v instanceof Date ? v : new Date(`1970-01-01T${v}`);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
    }

    private initFilters() {
        this.filtering.addFilter((copy: TreeNode<Fichaje>[] | void) => (copy as TreeNode<Fichaje>[]).filter(row => {
            const fichaje = row as Fichaje;
            if (this.usuarioActual.rol === 'basico') {

                return fichaje.nombre === this.usuarioActual.nombre + ' ' + this.usuarioActual.apellidos;
            } else {
                return [1, '1', true].includes(fichaje.activo ?? '');
            }
        }));

        if (this.showTrabajadoresCuadrillas) {
            this.filtering.addFilter((copy: TreeNode<Fichaje>[] | void) => (copy as TreeNode<Fichaje>[]).filter(row => {
                const fichaje = row as Fichaje;

                if (this.cuadrilla && this.cuadrilla.id) {
                    return (fichaje.id === this.cuadrilla.id) || (fichaje.cuadrilla === this.cuadrilla.id);
                }
                return row;
            }));
        }

        if (this.showFichajesCargos) {
            this.filtering.addFilter((copy: TreeNode<Fichaje>[] | void) => (copy as TreeNode<Fichaje>[]).filter(row => {
                const fichaje = row as Fichaje;

                if (this.cargo && this.cargo.id) {
                    return fichaje.id_cargo === this.cargo.id;
                }
                return row;
            }));
        }

        if (this.appName === 'naturfrut') {
            this.filtering.addFilter((copy: TreeNode<Fichaje>[] | void) => 
                (copy as TreeNode<Fichaje>[]).filter(row => {
                    const fichaje = row as Fichaje;

                    switch (this.almacenFilter) {
                    case 'es-almacen':
                        return [true, '1', 1].includes(fichaje.es_almacen ?? '');
                    case 'no-es-almacen':
                        return [null, undefined, '0', 0].includes(fichaje.es_almacen?.toString() ?? '');
                    default:
                        return true;
                    }
                }));
        }
    }

    private sortAlphabetically(collection: TreeNode<Fichaje>[], field: string) {
        collection.sort(function (a, b) {
            let nameA, nameB;
            if (a && b && a && b) {
                nameA = (a.data?.[field] || '').toUpperCase(); // ignore upper and lowercase
                nameB = (b.data?.[field] || '').toUpperCase(); // ignore upper and lowercase
            } else {
                return 0;
            }

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });
    }

    private getCuadrillas() {
        this.trabajadoresApi.cuadrillas.GET.toPromise().then(cuadrillas => {
            this.cuadrillas = cuadrillas.map((it: MantenimientoModel) => ({
                label: (it.nombre || '') + ' ' + (it.apellidos || ''),
                value: it
            }));
            this.cuadrillas.unshift({ label: '...', value: null });
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }

    private getCargos() {
        this.trabajadoresApi.cargosGET.toPromise().then(cargos => {
            this.cargos = cargos.map((it: CargoModel) => ({
                label: it.nombre,
                value: it
            }));
            this.cargos.unshift({ label: '...', value: null });
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }
}
